$(document).ready(function() {
  $('header .menutoggle').on('click', function() {
    $(this).toggleClass('active');
    $(this).parents('.mainmenu').toggleClass('active');
  });

  $('header .mainmenu .ankors a').on('click', function() {
    $(this).parents('.ankors').siblings('.menutoggle').removeClass('active');
    $(this).parents('.mainmenu').removeClass('active');
  });

  $('.tab').on('click', function(){
    if(!$(this).hasClass('cur')){
      let thisInd = $(this).data('tip');
      $(this).addClass('cur');
      $(this).siblings('.tab').removeClass('cur');
      $('.gal[data-gal="'+thisInd+'"]').addClass('active');
      $('.gal[data-gal="'+thisInd+'"]').siblings('.gal').removeClass('active');
    }
  });

  $('[data-tarif]').on('click', function(){
      let thisInd = $(this).data('tarif');
      if(!$('[data-tarifid="'+thisInd+'"] .tarifcontent').hasClass('vis')){
          $('[data-tarifid="'+thisInd+'"] .tarifcontent').addClass('vis');
          $('[data-tarifid="'+thisInd+'"]').find('.more').addClass('opened');
      }
  });

  $('.tarif-item .more').on('click', function(){
    if(!$(this).hasClass('opened')){
        $(this).parents('.tarif-item').find('.tarifcontent').addClass('vis');
        $(this).addClass('opened');
    } else {
        $(this).parents('.tarif-item').find('.tarifcontent').removeClass('vis');
        $(this).removeClass('opened');
    }
  });

  $('.faqitem .name').on('click', function(){
    if(!$(this).hasClass('active')){
      $(this).parents('.faqitem').siblings('.faqitem').find('.name').removeClass('active');
      $(this).parents('.faqitem').siblings('.faqitem').find('.text').slideUp();
    }
    $(this).toggleClass('active');
    $(this).siblings('.text').slideToggle();
  });

  $('[data-pp]').on('click', function(){
    thisId = $(this).data('pp');
    $('[data-modal="'+thisId+'"], #overlay').fadeIn();
  });

  $('[data-modal] .close').on('click', function(){
    $(this).parents('[data-modal]').fadeOut();
    $('#overlay').fadeOut();
  })


  $(document).on('click', 'a.toankor', function(e) {
      var id = $(this).attr("href");
      var offset = $(id).offset();
      console.log(id);
      $("html, body").animate({
        scrollTop: offset.top
      }, 700);
    });


      $('[name="email"]').inputmask({
         mask: "*{2,20}@*{2,20}.*{2,12}",
         greedy: true,
         onBeforePaste: function (pastedValue, opts) {
           pastedValue = pastedValue.toLowerCase();
           return pastedValue.replace("mailto:", "");
         },
         definitions: {
           '*': {
             validator: "[\.0-9A-Za-z!#$%&'*+/=\?\^_`{|}~\-]",
             casing: "lower"
           }
         }
       });
       Inputmask({"mask": "+7 (999) 999-9999"}).mask('[name="phone"]');


  $('.teamslider').slick({
    slidesToShow: 2,
    arrows: true,
    rows: 0,
    responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
  });

  $('.revslider').slick({
    slidesToShow: 2,
    arrows: true,
    rows: 0,
    responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
  });

  $('.workslider').slick({
    slidesToShow: 3,
    arrows: true,
    rows: 0,
    responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 568,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
  });

});

ymaps.ready(function () {
  var myMap = new ymaps.Map('map', {
      center: [55.8, 37.8],
      zoom: 10
  });
  myGeoObject = new ymaps.GeoObject({
              // Описание геометрии.
              geometry: {
                  type: "Point",
                  coordinates: [55.8, 37.8]
              },
          }, {
              preset: 'islands#blackStretchyIcon',
              draggable: true
          });
myMap.geoObjects
        .add(myGeoObject)
        .add(new ymaps.Placemark([55.8, 37.8]));
  myMap.behaviors
          .disable('scrollZoom');
});

function thanks(){
  $('[data-modal="thanks"], #overlay').fadeIn();
}